import axios, { AxiosError } from 'axios';

const TOKEN_KEY = 'nptapl_officer_token';

export const api = axios.create({
  baseURL: '/api',
  timeout: 15000,
});

api.interceptors.request.use((config) => {
  const token = localStorage.getItem(TOKEN_KEY);
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

api.interceptors.response.use(
  (r) => r,
  (err: AxiosError<{ error?: string; message?: string }>) => {
    if (err.response?.status === 401) {
      localStorage.removeItem(TOKEN_KEY);
    }
    return Promise.reject(err);
  },
);

export const tokenStore = {
  get: () => localStorage.getItem(TOKEN_KEY),
  set: (t: string) => localStorage.setItem(TOKEN_KEY, t),
  clear: () => localStorage.removeItem(TOKEN_KEY),
};

export function extractApiError(err: unknown): { code: string; message: string; details?: unknown } {
  const e = err as AxiosError<{ error?: string; message?: string; details?: unknown }>;
  const data = e.response?.data;
  return {
    code: data?.error ?? 'network_error',
    message: data?.message ?? e.message ?? 'เกิดข้อผิดพลาด',
    details: data?.details,
  };
}
